var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Dimmer, Form, Loader, Message } from "semantic-ui-react";
import ErrorDisplay from "../ErrorDisplay";
import { deleteWithAuthn, postJsonWithAuthn } from "../RequestHelpers";
/**
 * Provides the basics of common pattern of "UI with loading spinner, posts data, displays errors".
 */
var SimpleFormWithErrorDisplay = /** @class */ (function (_super) {
    __extends(SimpleFormWithErrorDisplay, _super);
    function SimpleFormWithErrorDisplay(props) {
        var _this = _super.call(this, props) || this;
        _this.postAndParseErrors = function (path, bodyToSerialize) {
            _this.makeRequestAndHandleErrors(function () { return postJsonWithAuthn(path, JSON.stringify(bodyToSerialize)); }, function () {
                _this.setState({
                    loading: false,
                    success: true
                });
            });
        };
        // <T> makes JSX think it's a tag, so the no-op "extends {}" helps the compiler figure out it's a generic
        _this.postAndParseErrorsWithResponse = function (path, bodyToSerialize, responseJsonCallback) {
            _this.makeRequestAndHandleErrors(function () { return postJsonWithAuthn(path, JSON.stringify(bodyToSerialize)); }, function (okResp) {
                okResp.json()
                    .then(function (okJson) {
                    _this.setState({
                        loading: false,
                        success: true
                    }, function () {
                        responseJsonCallback(okJson);
                    });
                });
            });
        };
        _this.deleteAndParseErrors = function (path) {
            _this.makeRequestAndHandleErrors(function () { return deleteWithAuthn(path); }, function () {
                _this.setState({
                    loading: false,
                    success: true
                });
            });
        };
        _this.setStateWrapper = function (calculateNewState, callback) {
            _this.setState(function (oldState) { return calculateNewState(oldState); }, callback);
        };
        /**
         * Sets state loading/success/errors assuming that http 400 == error json
         */
        _this.makeRequestAndHandleErrors = function (requestMaker, okRespCallback) {
            _this.setState({
                loading: true,
                success: false,
                errors: []
            }, function () {
                requestMaker()
                    .then(function (resp) {
                    if (resp.ok) {
                        okRespCallback(resp);
                    }
                    else if (resp.status === 400) {
                        // ErrorResponse
                        return resp.json()
                            .then(function (errorResp) {
                            _this.setState({
                                loading: false,
                                errors: errorResp.errors
                            });
                        });
                    }
                    else {
                        _this.setState({
                            errors: [{
                                    path: '/',
                                    msg: 'An unexpected error occurred'
                                }],
                            loading: false,
                            success: false
                        });
                    }
                    return undefined;
                })
                    .catch(function (rej) {
                    console.error("Couldn't make request: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            errors: [],
            success: false
        };
        return _this;
    }
    SimpleFormWithErrorDisplay.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.errors.length > 0 },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.props.render({
                state: this.state,
                postRequest: this.postAndParseErrors,
                postRequestWithJsonResponse: this.postAndParseErrorsWithResponse,
                deleteRequest: this.deleteAndParseErrors,
                setState: this.setStateWrapper
            }),
            this.props.errorDisplay === undefined &&
                React.createElement(ErrorDisplay, { errors: this.state.errors, errorPath: '/' }),
            this.props.errorDisplay !== undefined &&
                this.props.errorDisplay(this.state.errors),
            this.state.success &&
                React.createElement(Message, { positive: true }, this.props.successMessage));
    };
    return SimpleFormWithErrorDisplay;
}(React.PureComponent));
export default SimpleFormWithErrorDisplay;
//# sourceMappingURL=SimpleFormWithErrorDisplay.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/SimpleFormWithErrorDisplay.js
// module id = 44
// module chunks = 0